import React, { useEffect } from 'react'
import { Field, Form, Formik } from 'formik'
import { Card, CardBody, CardHeader, Input } from '../../_metronic/_partials/controls'
import { fetchSmtpDetails, updateSmtpDetails } from '../../actions/smtp-details/smtpDetails';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";

export default function SmtpPage() {

    const dispatch = useDispatch();
    const getSmtpDetails = async () => {
        await dispatch(fetchSmtpDetails());
    }
    useEffect(() => {
        getSmtpDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const { enqueueSnackbar } = useSnackbar();

    const onSave = async (values) => {

        const body = {
            "user_name": values.SMTP_USERNAME,
            "password": values.SMTP_PASSWORD,
            "email": values.FROM_EMAIL,
            "host": values.SMTP_HOST,
            "smtp_secure": (values.SMTP_SECURE === "true"),
            "smtp_port": parseInt(values.SMTP_PORT)
        }
        const id = smtpDetails._id;
        dispatch(updateSmtpDetails(body, id))
            .then(async (data) => {
                if (data.status) {
                    await enqueueSnackbar(data.message, {
                        variant: "success",
                        autoHideDuration: 4500,
                    });
                } else {
                    await enqueueSnackbar(data.message, {
                        variant: "error",
                        autoHideDuration: 4500,
                    });
                }
            });
    }
    const { smtpDetails } = useSelector(
        (state) => ({
            smtpDetails:
                state.smtpDetails.smtpDetails,
        }),
        shallowEqual
    );
    const initialValues = {
        SMTP_USERNAME: smtpDetails?.user_name ? smtpDetails?.user_name : "",
        SMTP_PASSWORD: smtpDetails?.password ? smtpDetails?.password : "",
        FROM_EMAIL: smtpDetails?.email ? smtpDetails?.email : "",
        SMTP_HOST: smtpDetails?.host ? smtpDetails?.host : "",
        SMTP_SECURE: smtpDetails?.smtp_secure != null ? smtpDetails?.smtp_secure.toString() : "",
        SMTP_PORT: smtpDetails?.smtp_port ? smtpDetails?.smtp_port : ""
    }

    const SmtpSchema = Yup.object().shape({
        SMTP_USERNAME: Yup.string().required("SMTP username is required"),
        SMTP_PASSWORD: Yup.string().required("SMTP password is required"),
        FROM_EMAIL: Yup.string().email("Wrong email format")
            .required("SMTP email is required"),
        SMTP_HOST: Yup.string().required("SMTP host is required"),
        SMTP_SECURE: Yup.string().required("SMTP secure is required"),
        SMTP_PORT: Yup.string().min(3, "Minimum 3 symbols")
            .required("SMTP port is required")
    })
    return (
        <div>
            <Card>
                <CardHeader title={"SMTP Details"}/>
                <CardBody>
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        validationSchema={SmtpSchema}
                        onSubmit={async (values, { setErrors }) => {
                            onSave(values)
                        }}>
                        {({ handleSubmit, field, setFieldValue, values, handleChange }) => (
                            <>
                                <Form className='form form-label-right'>
                                    <div className='form-group row mt-5'>
                                        <Field
                                            name="SMTP_USERNAME"
                                            component={Input}
                                            placeholder='SMTP USERNAME'
                                            label="SMTP USERNAME"
                                        />
                                    </div>
                                    <div className='form-group row mt-5'>
                                        <Field
                                            name="SMTP_PASSWORD"
                                            component={Input}
                                            placeholder='SMTP PASSWORD'
                                            label="SMTP PASSWORD"
                                        />
                                    </div>
                                    <div className='form-group row mt-5'>
                                        <Field
                                            name="FROM_EMAIL"
                                            component={Input}
                                            placeholder='FROM EMAIL'
                                            label="FROM EMAIL"
                                        />
                                    </div>
                                    <div className='form-group row mt-5'>
                                        <Field
                                            name="SMTP_HOST"
                                            component={Input}
                                            placeholder='SMTP HOST'
                                            label="SMTP HOST"
                                        />
                                    </div>
                                    <div className='form-group row mt-5'>
                                        <label className="col-xl-3 col-lg-2 col-form-label text-right">SMTP SECURE</label>
                                        <div className="col-lg-6 col-xl-6">
                                            <div className='radio-inline mt-3'>
                                                <label className='radio'>
                                                    <Field
                                                        type='radio'
                                                        name='SMTP_SECURE'
                                                        value="true"
                                                        checked={values.SMTP_SECURE === "true" || values.SMTP_SECURE === ""}

                                                    />
                                                    <span></span>
                                                    True
                                                </label>
                                                <label className='radio'>
                                                    <Field
                                                        type='radio'
                                                        value="false"
                                                        name='SMTP_SECURE'
                                                        checked={values.SMTP_SECURE === "false"}
                                                    />
                                                    <span></span>
                                                    False
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-group row mt-5'>
                                        <Field
                                            name="SMTP_PORT"
                                            component={Input}
                                            placeholder='SMTP PORT'
                                            label="SMTP PORT"
                                        />
                                    </div>
                                    <button
                                        type='submit'
                                        className='btn btn-primary'
                                        style={{ float: "right" }}
                                        // ref={btnRef}
                                        disabled={values === initialValues}
                                        onSubmit={() => handleSubmit()}>Submit
                                    </button>

                                </Form>
                            </>
                        )}
                    </Formik>

                </CardBody>
            </Card>

        </div>
    )
}
